import { Component } from '@angular/core';
import { RouterLink } from '@angular/router';
import { SiteFooterComponent } from '../site-footer/site-footer.component';

@Component({
  selector: 'app-terminos',
  imports: [RouterLink, SiteFooterComponent],
  templateUrl: './terminos.component.html',
})
export class TerminosComponent {
  readonly updated = '13 de mayo de 2026';
}
